import type { LiteralValues } from '@/utils/typing/literal-values.type';

export const SharedUiColorName = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',

    // meaningful colors
    CTA: 'cta', // Call to action
    INFO: 'info',
    DANGER: 'danger',
    SUCCESS: 'success',
    FAILURE: 'failure',
    NEUTRAL: 'neutral' // When trying to explicitly mean : neither a success nor a failure
} as const;
export type SharedUiColorName = LiteralValues<typeof SharedUiColorName>;

export const SharedUiColorNameV2 = {
    DEFAULT: 'default',
    PRIMARY: 'primary',

    // meaningful colors
    INFO: 'info',
    DANGER: 'danger',
    SUCCESS: 'success',
    FAILURE: 'failure',
    NEUTRAL: 'neutral',

    // Arbitrary categories colors
    CATEGORY_0: 'category-0',
    CATEGORY_1: 'category-1',
    CATEGORY_2: 'category-2',
    CATEGORY_3: 'category-3',
    CATEGORY_4: 'category-4',
    CATEGORY_5: 'category-5',
    CATEGORY_6: 'category-6',
    CATEGORY_7: 'category-7'
} as const;
export type SharedUiColorNameV2 = LiteralValues<typeof SharedUiColorNameV2>;

export const PrettyFeelSharedUiColorName = {
    GRAY: 'gray',
    TOMATO: 'tomato',
    ORANGE: 'orange',
    AMBER: 'amber',
    GRASS: 'grass',
    CYAN: 'cyan',
    BLUE: 'blue',
    VIOLET: 'violet',
    CRIMSON: 'crimson'
} as const;
export type PrettyFeelSharedUiColorName = LiteralValues<typeof PrettyFeelSharedUiColorName>;

/**
 * Canonical order used when cycling through the pretty-feel palettes to color
 * arbitrary categories (e.g. chart series). The sequence is designed to
 * maximize visual contrast between consecutive colors; GRAY is placed last so
 * colorful hues are preferred when the number of categories is small.
 */
export const prettyFeelCategoryOrder: PrettyFeelSharedUiColorName[] = [
    PrettyFeelSharedUiColorName.TOMATO,
    PrettyFeelSharedUiColorName.ORANGE,
    PrettyFeelSharedUiColorName.AMBER,
    PrettyFeelSharedUiColorName.GRASS,
    PrettyFeelSharedUiColorName.CYAN,
    PrettyFeelSharedUiColorName.BLUE,
    PrettyFeelSharedUiColorName.VIOLET,
    PrettyFeelSharedUiColorName.CRIMSON,
    PrettyFeelSharedUiColorName.GRAY
];

export enum SharedUiColorDerivation {
    MAIN = 'main',
    LIGHT = 'light',
    DARK = 'dark',
    CONTRAST = 'contrast' // to write on main color
}

export type SharedUiColoredBackgroundColorDerivation = Extract<
    SharedUiColorDerivation,
    SharedUiColorDerivation.MAIN | SharedUiColorDerivation.LIGHT | SharedUiColorDerivation.DARK
>;

export const coloredBackgroundColorDerivations: SharedUiColoredBackgroundColorDerivation[] = [
    SharedUiColorDerivation.MAIN,
    SharedUiColorDerivation.LIGHT,
    SharedUiColorDerivation.DARK
];

export enum SharedUiBackgroundColorName {
    LIGHT = 'light',
    DARK = 'dark'
}

export enum SharedUiBackgroundColorDerivation {
    MAIN = 'main',
    FADED = 'faded',
    HIGHLIGHT = 'highlight'
}

export enum SharedUiTextColorDerivation {
    MAIN = 'main',
    SECONDARY = 'secondary',
    FOCUSED = 'focused'
}

export enum SharedUiStrokeColorName {
    LIGHT = 'light',
    DARK = 'dark'
}
